import http from '@/http'
import config from '@/config'

const mediaToLdReference = (media) => {
	if (media == null) return undefined
	if (typeof media === 'string') return media
	if (typeof media !== 'object') return undefined
	if (media['@id']) return media['@id']
	if (media.id != null && media.id !== '') {
		const base = (config.service.apiURL || '').replace(/\/$/, '')
		return `${base}/media_objects/${media.id}`
	}
	return undefined
}

const normalizeRouteAttachmentPayload = (att) => {
	if (!att) return null
	const mediaRef = mediaToLdReference(att.media)
	const base = {
		description: att.description != null ? att.description : '',
		...(mediaRef != null ? { media: mediaRef } : {})
	}
	if (att['@id']) {
		return { '@id': att['@id'], ...base }
	}
	if (att.id != null && att.id !== '') {
		const baseUrl = (config.service.apiURL || '').replace(/\/$/, '')
		return { '@id': `${baseUrl}/route_attachments/${att.id}`, ...base }
	}
	return base
}

const find = id => {
	const path = `routes?id=${id}`
	return http.get(path)
}

const getAll = ({ field, order }, perPage = 10, pageNr = 1, filter, searchText) => {
	let filterSegment = ''
	let searchSegment = ''

	if (filter) {
		if (typeof filter.value === 'boolean')
			filterSegment += `&${filter.by}[exists]=${filter.value}`
		else if (Array.isArray(filter.value))
			filter.value.forEach(value => {
				filterSegment += `&${filter.by}[]=${value}`
			})
		else filterSegment += `&${filter.by}=${filter.value}`
	}

	if (searchText) searchSegment = `&search=${searchText}`

	const path = `routes?order[${field}]=${order}&itemsPerPage=${perPage}&page=${pageNr}${filterSegment}${searchSegment}`
	return http.get(path)
}

const update = route => {
	const path = `routes/${route.id}`

	const routeToSave = { ...route }
	if (route.orders) delete routeToSave.orders
	if (route.creator) delete routeToSave.creator
	if (route.ordersDistances)
		routeToSave.ordersDistances = JSON.stringify(routeToSave.ordersDistances)

	if (Object.prototype.hasOwnProperty.call(route, 'routeAttachment')) {
		routeToSave.routeAttachment = normalizeRouteAttachmentPayload(route.routeAttachment)
	}

	return http.put(path, routeToSave)
}

const create = route => {
	const path = `routes`
	if (route.creator) delete route.creator
	return http.post(path, route)
}

const destroy = route => {
	const path = `routes/${route.id}`
	return http.delete(path)
}

export default {
	find,
	getAll,
	update,
	create,
	destroy
}
